module.exports = __webpack_public_path__ + "static/img/contact.f9284bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact.png
// module id = 550A
// module chunks = 20